import HeroAnimated from './HeroAnimated';
import HeroStatic from './HeroStatic';

//const HERO_VARIANT = 'animated';
const HERO_VARIANT = 'static';

export default function Hero() {

    return HERO_VARIANT === 'animated'
        ? HeroAnimated()
        : HeroStatic();

}
